import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const variants = {
  gray: 'bg-gray-100 text-gray-800',
  red: 'bg-red-100 text-red-800',
  orange: 'bg-orange-100 text-orange-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  green: 'bg-green-100 text-green-800',
  blue: 'bg-blue-100 text-blue-800',
  indigo: 'bg-indigo-100 text-indigo-800',
  purple: 'bg-purple-100 text-purple-800',
  pink: 'bg-pink-100 text-pink-800',
};

const sizes = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-0.5 text-sm',
  lg: 'px-3 py-1 text-sm',
};

export function Badge({
  children,
  variant = 'gray',
  size = 'md',
  dot = false,
  className,
}) {
  return (
    <span
      className={twMerge(
        clsx(
          'inline-flex items-center font-medium rounded-full',
          variants[variant],
          sizes[size]
        ),
        className
      )}
    >
      {dot && (
        <svg
          className={clsx(
            'me-1.5 h-2 w-2',
            variant === 'green' && 'text-green-400',
            variant === 'red' && 'text-red-400',
            variant === 'yellow' && 'text-yellow-400',
            variant === 'blue' && 'text-blue-400',
            variant === 'gray' && 'text-gray-400'
          )}
          fill="currentColor"
          viewBox="0 0 8 8"
        >
          <circle cx="4" cy="4" r="3" />
        </svg>
      )}
      {children}
    </span>
  );
}

export default Badge;
